import { bool, string } from "prop-types";
import styled, { css } from "styled-components/macro";
import { rem } from "polished";

const getGutterWidth = size => {
  switch (size) {
    case "large":
      return 30;
    case "small":
      return 15;
    default:
      return 23;
  }
};

const baseStyles = css`
  display: flex;

  &.justify-start {
    justify-content: flex-start;
  }

  > .w40 {
    width: calc(
      40% - ${({ gutter }) => rem(getGutterWidth(gutter) / 2 + "px")}
    );
  }

  > .w50 {
    width: calc(
      50% - ${({ gutter }) => rem(getGutterWidth(gutter) / 2 + "px")}
    );
  }

  > .w60 {
    width: calc(
      60% - ${({ gutter }) => rem(getGutterWidth(gutter) / 2 + "px")}
    );
  }

  > .wAuto {
    width: auto;
  }

  > :not(:first-child) {
    margin-left: ${({ gutter }) => rem(getGutterWidth(gutter) + "px")};
  }
`;

const Row = styled(({ children, gutter, stack, ...rest }) => (
  <div {...rest}>{children}</div>
))`
  ${({ stack }) => (stack ? null : baseStyles)}
`;

Row.propTypes = {
  gutter: string,
  stack: bool,
};

Row.defaultProps = {
  stack: false,
};

export default Row;
